import React from "react";
import { useApiRequest } from "@utils/ApiRequest";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ActivityAlarmCard, NewsCard } from "@pages/alarm/_components";
import styled from "@emotion/styled";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: "0 2rem",
});

const Activity = () => {
  const { getActivityAlarmList, patchNotification } = useApiRequest();

  const lang = window.localStorage.getItem("language");

  const { data: activityAlarmList } = useQuery({
    queryKey: ["activityAlarmList"],
    queryFn: getActivityAlarmList,
  });

  // 알람 읽음 상태 업데이트
  const { mutate: patchNotificationMutation } = useMutation({
    mutationFn: (id: number) => patchNotification(id),
  });

  const handleActivityClick = (id: number) => {
    patchNotificationMutation(id);
  };

  return (
    <Container>
      {activityAlarmList?.map((item: any, index: number) => (
        <ActivityAlarmCard
          key={index}
          date={lang === "en" ? item.created_at_en : item.created_at_ko}
          content={item.content}
          isRead={item.is_read}
          redirectUrl={item.url_path}
          thumbnail_url={item.thumbnail_url}
          onClick={() => handleActivityClick(item.notification_id)}
        />
      ))}
    </Container>
  );
};

export default Activity;
